module.exports = __webpack_public_path__ + "img/alfa-logo.181bbb0e.jpg";